import { FC } from "react";
import { Stack } from "@mui/material";
import { WidgetConfigSection } from "../../../common/widget-configurations/WidgetConfigSection";
import VisualizationIcon from "@/assets/icons/app-related/visualization_icon.svg";
import { NormalizedCostWidgetChartTypeSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/visualization/NormalizedCostWidgetChartTypeSelect";
import {
  ChartType,
  WidgetNormalizedCostVisualization,
} from "@/services/cloudchipr.api";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupVisualizationChartTypeSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationChartTypeSelector";
import { NormalizedCostWidgetVisualizationItem } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/visualization/NormalizedCostWidgetVisualizationItem";

export const NormalizedCostWidgetVisualizationSection: FC = () => {
  const chartType = useAppSelector(
    normalizedCostWidgetSetupVisualizationChartTypeSelector,
  );

  return (
    <WidgetConfigSection
      initialExpanded
      title="Visualization"
      icon={<img src={VisualizationIcon} alt="Visualization Icon" />}
    >
      <Stack spacing={1.5}>
        <NormalizedCostWidgetChartTypeSelect />

        {chartTypeDetails
          .get(chartType)
          ?.map((key) => (
            <NormalizedCostWidgetVisualizationItem
              key={key}
              visualizationKey={key}
            />
          ))}
      </Stack>
    </WidgetConfigSection>
  );
};

const chartTypeDetails: Map<
  ChartType,
  Array<keyof WidgetNormalizedCostVisualization>
> = new Map([
  ["line", ["scale", "show_legends"]],
  ["column", ["scale", "show_legends"]],
  ["table", ["actual_total_cost", "normalized_total_cost"]],
]);
